import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { FaQuoteLeft, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Aarav Mehta',
      role: 'Intermediate Player',
      rating: 5,
      text: 'Net Nest Badminton Sports Club has completely transformed my game. The coaches focus deeply on fundamentals and footwork, which helped me gain confidence during matches. The training environment is disciplined yet motivating.',
    },
    {
      name: 'Riya Sharma',
      role: 'Beginner Player',
      rating: 5,
      text: 'I joined Net Nest as a beginner with no prior experience. The coaches were patient and supportive, helping me learn step by step. Today, I feel confident playing competitive rallies.',
    },
    {
      name: 'Rohit Verma',
      role: 'Advanced Player',
      rating: 5,
      text: 'The professional coaching at Net Nest is outstanding. Match strategies, fitness training, and mental preparation are given equal importance. This club truly focuses on overall player development.',
    },
    {
      name: 'Neha Gupta',
      role: 'Parent',
      rating: 5,
      text: 'My son has shown remarkable improvement since joining Net Nest. Not only has his badminton improved, but his discipline, confidence, and fitness have also increased. Highly recommended.',
    },
    {
      name: 'Aditya Singh',
      role: 'Youth Player',
      rating: 5,
      text: 'The training sessions are well-structured and challenging. Coaches give personal feedback, which helps identify mistakes and improve quickly. Net Nest is the perfect place for serious players.',
    },
    {
      name: 'Pooja Malhotra',
      role: 'Recreational Player',
      rating: 5,
      text: 'I joined Net Nest to stay fit and learn badminton properly. The friendly atmosphere and professional guidance make every session enjoyable and productive.',
    },
    {
      name: 'Kunal Bansal',
      role: 'Competitive Player',
      rating: 5,
      text: 'The focus on fitness and stamina at Net Nest is excellent. Regular drills and match practice helped me perform better in tournaments. The coaches truly care about each player’s growth.',
    },
    {
      name: 'Suman Rani',
      role: 'Parent',
      rating: 5,
      text: 'Net Nest provides a safe and positive environment for children. The coaches maintain discipline while keeping training engaging. I’m very satisfied with my daughter’s progress.',
    },
    {
      name: 'Yash Kapoor',
      role: 'Intermediate Player',
      rating: 5,
      text: 'From footwork to smash techniques, everything is taught in detail. The structured training programs have helped me improve my consistency and court movement.',
    },
    {
      name: 'Anjali Verma',
      role: 'Beginner Player',
      rating: 5,
      text: 'I was nervous when I first joined, but the coaches made learning easy and fun. Net Nest helped me build confidence and love for the sport.',
    },
    {
      name: 'Mohit Aggarwal',
      role: 'Advanced Player',
      rating: 5,
      text: 'What sets Net Nest apart is the personalized attention. Coaches understand each player’s strengths and weaknesses and train accordingly. This approach really works.',
    },
    {
      name: 'Sunita Sharma',
      role: 'Parent',
      rating: 5,
      text: 'The discipline and professionalism at Net Nest are impressive. My child looks forward to every training session and has become more focused and active.',
    },
    {
      name: 'Arjun Patel',
      role: 'Youth Player',
      rating: 5,
      text: 'Net Nest helped me prepare for competitive matches. The regular practice games and fitness sessions improved my speed, stamina, and confidence.',
    },
    {
      name: 'Kavita Jain',
      role: 'Working Professional',
      rating: 5,
      text: 'The flexible training schedules and quality coaching make Net Nest perfect for working individuals. I get great workouts and professional guidance.',
    },
    {
      name: 'Nikhil Chauhan',
      role: 'Tournament Player',
      rating: 5,
      text: 'The match preparation and strategy sessions at Net Nest helped me perform better under pressure. I feel more confident entering tournaments now.',
    }
  ];

  const categories = ['All', 'Training', 'Facilities', 'Membership', 'Junior Academy', 'Events'];

  const [activeCategory, setActiveCategory] = useState('All');

  // Carousel State
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // Featured testimonials for carousel (first 5)
  const featuredTestimonials = testimonials.slice(0, 5);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % featuredTestimonials.length);
  }, [featuredTestimonials.length]);

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + featuredTestimonials.length) % featuredTestimonials.length);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Auto-slide effect
  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(nextSlide, 5000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, nextSlide]);

  // Pause auto-slide on hover
  const handleMouseEnter = () => setIsAutoPlaying(false);
  const handleMouseLeave = () => setIsAutoPlaying(true);

  const filteredTestimonials = activeCategory === 'All'
    ? testimonials
    : testimonials.filter(t => t.category === activeCategory);

  const stats = [
    { number: '5000+', label: 'Happy Members' },
    { number: '4.9', label: 'Average Rating' },
    { number: '98%', label: 'Satisfaction Rate' },
    { number: '500+', label: '5-Star Reviews' }
  ];

  return (
    <div className="testimonials-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <span className="page-badge">Testimonials</span>
            <h1>What Our Members Say</h1>
            <p>Real stories from our amazing badminton community</p>
            <nav className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Testimonials</span>
            </nav>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="testimonial-stats">
        <div className="container">
          <div className="stats-grid-testimonials">
            {stats.map((stat, index) => (
              <div className="stat-item-testimonial" key={index}>
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Testimonials Carousel */}
      <section className="featured-testimonials-section section">
        <div className="container">
          <div className="section-header center">
            <span className="section-badge">Featured Reviews</span>
            <h2>Stories That Inspire</h2>
            <p>Discover how Net Nest has transformed the badminton journey of our members</p>
          </div>

          <div
            className="testimonials-slider"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            {/* Navigation Buttons */}
            <button className="slider-btn slider-btn-prev" onClick={prevSlide}>
              <FaChevronLeft />
            </button>
            <button className="slider-btn slider-btn-next" onClick={nextSlide}>
              <FaChevronRight />
            </button>

            {/* Slider Track */}
            <div className="slider-container">
              <div
                className="slider-track"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {featuredTestimonials.map((testimonial, index) => (
                  <div className="slider-slide" key={index}>
                    <div className="featured-testimonial-card">
                      <div className="featured-quote-icon">
                        <FaQuoteLeft />
                      </div>
                      <div className="featured-content">
                        <div className="featured-rating">
                          {[...Array(testimonial.rating)].map((_, i) => (
                            <FaStar key={i} />
                          ))}
                        </div>
                        <p className="featured-text">"{testimonial.text}"</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Dot Indicators */}
            <div className="slider-dots">
              {featuredTestimonials.map((_, index) => (
                <button
                  key={index}
                  className={`slider-dot ${currentSlide === index ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            {/* Progress Bar */}
            <div className="slider-progress">
              <div
                className="slider-progress-bar"
                style={{
                  width: `${((currentSlide + 1) / featuredTestimonials.length) * 100}%`
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="section">
        <div className="container">
          <div className="filter-buttons">
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="section testimonials-main">
        <div className="container">
          <div className="testimonials-masonry">
            {filteredTestimonials.map((testimonial, index) => (
              <div className="testimonial-card-full" key={index}>
                <div className="testimonial-header">
                  <div className="testimonial-author-info">
                    <h4>{testimonial.name}</h4>
                    <span>{testimonial.role}</span>
                    <div className="rating">
                      {[...Array(testimonial.rating)].map((_, i) => (
                        <FaStar key={i} />
                      ))}
                    </div>
                  </div>
                </div>
                <FaQuoteLeft className="quote-icon" />
                <p className="testimonial-text">{testimonial.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Write Your Success Story?</h2>
            <p>Join Net Nest today and experience the difference</p>
            <div className="cta-buttons">
              <Link to="/membership" className="btn btn-white">Become a Member</Link>
              <Link to="/contact" className="btn btn-outline-white">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;
